var map = {
	"./1x1rectangle.dxf": 63394,
	"./2BiohmMould.dxf": 68377,
	"./Ceco.NET-Architecture-Tm-53.dxf": 1039,
	"./accumulatortest.dxf": 42583,
	"./arc15.dxf": 46423,
	"./arc16.dxf": 84069,
	"./arc17.dxf": 13427,
	"./array-rotated.dxf": 89263,
	"./arrayed-holes.dxf": 41757,
	"./blocks1.dxf": 76792,
	"./blocks2.dxf": 80664,
	"./circlesellipsesarcs.dxf": 6579,
	"./closedlwpolylinebug.dxf": 39705,
	"./dimension-vertical.dxf": 51491,
	"./dimensions.dxf": 82859,
	"./elliptical-arc1.dxf": 2949,
	"./elliptical-arc10.dxf": 1253,
	"./elliptical-arc11.dxf": 80533,
	"./elliptical-arc12.dxf": 20906,
	"./elliptical-arc13.dxf": 72108,
	"./elliptical-arc14.dxf": 39422,
	"./elliptical-arc2.dxf": 49404,
	"./elliptical-arc3.dxf": 72595,
	"./elliptical-arc4.dxf": 40616,
	"./elliptical-arc5.dxf": 55273,
	"./elliptical-arc6.dxf": 85232,
	"./elliptical-arc7.dxf": 72737,
	"./elliptical-arc8.dxf": 84957,
	"./elliptical-arc9.dxf": 57157,
	"./ellipticalarcs.dxf": 29171,
	"./ellipticalarcs2.dxf": 48444,
	"./empty.dxf": 76737,
	"./entities.dxf": 7403,
	"./floorplan.dxf": 27498,
	"./hatches.dxf": 51323,
	"./issue21.dxf": 504,
	"./issue27a.dxf": 21695,
	"./issue27b.dxf": 42253,
	"./issue27c.dxf": 56348,
	"./issue28.dxf": 18907,
	"./issue29.dxf": 4658,
	"./issue39.dxf": 57321,
	"./issue42.dxf": 6564,
	"./issue50.dxf": 59720,
	"./issue52.dxf": 50210,
	"./issue53.dxf": 44452,
	"./layers.dxf": 10554,
	"./lines.dxf": 50725,
	"./lion.dxf": 87428,
	"./lwpolylines.dxf": 43314,
	"./openscad_export.dxf": 85828,
	"./points.dxf": 64390,
	"./polylines.dxf": 54611,
	"./splineA.dxf": 28363,
	"./splines.dxf": 70554,
	"./squareandcircle.dxf": 51461,
	"./squircle2.dxf": 13690,
	"./supported_entities.dxf": 3522,
	"./texts-in-block.dxf": 32055,
	"./texts.dxf": 94850,
	"./threeDFaces.dxf": 54602,
	"assets/dxf/1x1rectangle.dxf": 63394,
	"assets/dxf/2BiohmMould.dxf": 68377,
	"assets/dxf/Ceco.NET-Architecture-Tm-53.dxf": 1039,
	"assets/dxf/accumulatortest.dxf": 42583,
	"assets/dxf/arc15.dxf": 46423,
	"assets/dxf/arc16.dxf": 84069,
	"assets/dxf/arc17.dxf": 13427,
	"assets/dxf/array-rotated.dxf": 89263,
	"assets/dxf/arrayed-holes.dxf": 41757,
	"assets/dxf/blocks1.dxf": 76792,
	"assets/dxf/blocks2.dxf": 80664,
	"assets/dxf/circlesellipsesarcs.dxf": 6579,
	"assets/dxf/closedlwpolylinebug.dxf": 39705,
	"assets/dxf/dimension-vertical.dxf": 51491,
	"assets/dxf/dimensions.dxf": 82859,
	"assets/dxf/elliptical-arc1.dxf": 2949,
	"assets/dxf/elliptical-arc10.dxf": 1253,
	"assets/dxf/elliptical-arc11.dxf": 80533,
	"assets/dxf/elliptical-arc12.dxf": 20906,
	"assets/dxf/elliptical-arc13.dxf": 72108,
	"assets/dxf/elliptical-arc14.dxf": 39422,
	"assets/dxf/elliptical-arc2.dxf": 49404,
	"assets/dxf/elliptical-arc3.dxf": 72595,
	"assets/dxf/elliptical-arc4.dxf": 40616,
	"assets/dxf/elliptical-arc5.dxf": 55273,
	"assets/dxf/elliptical-arc6.dxf": 85232,
	"assets/dxf/elliptical-arc7.dxf": 72737,
	"assets/dxf/elliptical-arc8.dxf": 84957,
	"assets/dxf/elliptical-arc9.dxf": 57157,
	"assets/dxf/ellipticalarcs.dxf": 29171,
	"assets/dxf/ellipticalarcs2.dxf": 48444,
	"assets/dxf/empty.dxf": 76737,
	"assets/dxf/entities.dxf": 7403,
	"assets/dxf/floorplan.dxf": 27498,
	"assets/dxf/hatches.dxf": 51323,
	"assets/dxf/issue21.dxf": 504,
	"assets/dxf/issue27a.dxf": 21695,
	"assets/dxf/issue27b.dxf": 42253,
	"assets/dxf/issue27c.dxf": 56348,
	"assets/dxf/issue28.dxf": 18907,
	"assets/dxf/issue29.dxf": 4658,
	"assets/dxf/issue39.dxf": 57321,
	"assets/dxf/issue42.dxf": 6564,
	"assets/dxf/issue50.dxf": 59720,
	"assets/dxf/issue52.dxf": 50210,
	"assets/dxf/issue53.dxf": 44452,
	"assets/dxf/layers.dxf": 10554,
	"assets/dxf/lines.dxf": 50725,
	"assets/dxf/lion.dxf": 87428,
	"assets/dxf/lwpolylines.dxf": 43314,
	"assets/dxf/openscad_export.dxf": 85828,
	"assets/dxf/points.dxf": 64390,
	"assets/dxf/polylines.dxf": 54611,
	"assets/dxf/splineA.dxf": 28363,
	"assets/dxf/splines.dxf": 70554,
	"assets/dxf/squareandcircle.dxf": 51461,
	"assets/dxf/squircle2.dxf": 13690,
	"assets/dxf/supported_entities.dxf": 3522,
	"assets/dxf/texts-in-block.dxf": 32055,
	"assets/dxf/texts.dxf": 94850,
	"assets/dxf/threeDFaces.dxf": 54602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25037;